// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "firebase_key",
  authDomain: "jacketrafa-a5b8b.firebaseapp.com",
  projectId: "jacketrafa-a5b8b",
  storageBucket: "jacketrafa-a5b8b.appspot.com",
  messagingSenderId: "779429598467",
  appId: "firebase app id",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// module.exports =  app ;
export default app;
